/* istanbul ignore file */
import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule, Optional, SkipSelf } from "@angular/core";

import { MsalInterceptor, MsalModule, MsalService, MSAL_CONFIG, MSAL_CONFIG_ANGULAR } from "@azure/msal-angular";

import { IsAuthenticatedGuard } from "./guard/is-authenticated.guard";
import { IsNotAuthenticatedGuard } from "./guard/is-not-authenticated.guard";
import { throwIfAlreadyLoadedGuard } from "./guard/module-import.guard";

import { msalAngularConfig, msalConfig } from "./utility/msal-config";
import { AuthService } from "./service/auth.service";
import { LeftNavService } from "./service/left-nav.service";
import { HasContextGuard } from "./guard/has-context.guard";
import { ContextService } from "./service/context.service";
import { LoadingStatusService } from "./service/loading-status.service";
import { PermissionService } from "./service/permission.service";


@NgModule({
  declarations: [
    // Components

  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MsalModule,
  ],
  providers: [
    // Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },

    // Config Providers
    {
      provide: MSAL_CONFIG,
      useFactory: msalConfig
    },
    {
      provide: MSAL_CONFIG_ANGULAR,
      useFactory: msalAngularConfig
    },

    // Singleton Services
    AuthService,
    ContextService,
    LeftNavService,
    LoadingStatusService,
    PermissionService,

    // External Services
    MsalService,

    // Guards
    IsAuthenticatedGuard,
    IsNotAuthenticatedGuard,
    HasContextGuard,
  ],
  exports: [ ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoadedGuard(parentModule, "CoreModule");
  }
}
